module.exports = __webpack_public_path__ + "media/images/2-b01df3040d23c1deb02a9f223afd8a65.png";